import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { PartyService, SalesPlanService, PurchaseOrderService } from "../../../services/index";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./salesPlanadd.html",
})
export class salesPlanadd {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  menu: any;
  agentdata: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;

  codeList: any;
  execApi: boolean = true;
  show_det: boolean = false;

  invoicedata: any = {
    design_no: "",
    agent_name: "",
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  seasonList: any = [];
  
  colorList: any = [];
  agentEntry: any = [];

  dataList = [];
  Agentlist = [];
  finyearList = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];
  invoiceTypeList = ["PROFORMA", "INVOICE"];
  fabstyleList = ["PLAIN", "MAPLE", "PLAIN DOBBY", "PRINTED", "CHECKS", "STRIPES"];
  widthList = ["36", "44", "58"];
  brandList = ["EXPOSE", "ARAZA"];
  styleList = ["FORMAL", "CASUAL"];
  fitList = ["COMFORT FIT", "RELAX FIT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList = [];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD AGENT DEDUCTION",
          title: "ADD AGENT DEDUCTION",
          tabParent: "SALES_ORDER",
          mode: "Add",
          data: row,
          name: "ADD AGENT DEDUCTION",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let invoicedata = Object.assign({}, tabObj.params["data"]);
      // this.acdata = designdata;
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.sale_type = val["sale_type"];
      this.to_sale_type = val["to_sale_type"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);
      this.invoicedata = invoicedata;
      this.invoicedata.disper = invoicedata.disper;
    }
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {


      //    this.invoicedata.ref_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  finCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    // private salesinvservice: WorkOrderService,
    private salesinvservice: SalesPlanService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private combo2Service: Combo2Service,
    private partyService: PartyService
  ) {
    this.row = {
      agent_name: "",
      shade: "",
      color: "",
      fab_no: "",
      fab_color: "",
      style: "",
      brand: "",
      sam_no: "",
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.finyearCombo()
    this.getagent();
    if (this.mode == "Add") {
      console.log(this.mode)
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");


    }
  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "design" && nxtRow.length < 0) {
      // let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + fld + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  calcTotal(ind) {
    this.data.invoiceList[ind].total = Number(this.data.invoiceList[ind].a1) + Number(this.data.invoiceList[ind].a2) + Number(this.data.invoiceList[ind].a3) + Number(this.data.invoiceList[ind].a4) + this.data.invoiceList[ind].a5
    console.log(this.data.invoiceList[ind].total);
    this.calcGrandEntrytot()
  }

  calcGrandEntrytot() {
    let tot = 0;
    let a1tot = 0;
    let a2tot = 0;
    let a3tot = 0;
    let a4tot = 0;
    let a5tot = 0;
if(this.show_det){
    for (let i = 0; i < this.data.invoiceList.length; i++) {

      if (i == this.data.invoiceList.length - 1) {
        this.data.invoiceList[i].a1 = a1tot;
        this.data.invoiceList[i].a2 = a2tot;
        this.data.invoiceList[i].a3 = a3tot;
        this.data.invoiceList[i].a4 = a4tot;
        this.data.invoiceList[i].a5 = a5tot;
        this.data.invoiceList[i].total = tot;

        return
      }
      else {
        a1tot += this.data.invoiceList[i].a1;
        a2tot += this.data.invoiceList[i].a2;
        a3tot += this.data.invoiceList[i].a3;
        a4tot += this.data.invoiceList[i].a4;
        a5tot += this.data.invoiceList[i].a5;
        tot += this.data.invoiceList[i].total;


      }
    }
  }
  }
  getMasterDetails() {

    let params = {
      id: this.agentdata,
      year: this.invoicedata.finyear,
      state: this.show_det,
      type : this.menu.param,
    };

    this.salesinvservice.getagenttarget(params).then((res: any) => {

      this.data.invoiceList = res.data;
      console.log(this.data.invoiceList);
    
      this.calcGrandtot();
      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);

    });
  }

  selectYear(){
    let params = {
  
      year: this.invoicedata.fin_id,
 
    };

    this.salesinvservice.getyearSeason(params).then((res: any) => {

      this.seasonList = res;
      console.log(this.seasonList);
    });
  }
  calcGrandtot() {

    if (this.show_det) {
      let a1tot = 0;
      let a2tot = 0;
      let a3tot = 0;
      let a4tot = 0;
      let a5tot = 0;
      let atot = 0;

      for (let i = 0; i < this.data.invoiceList.length; i++) {
        const data = this.data.invoiceList[i];
        a1tot += Number(data.a1)
        a2tot += Number(data.a2)
        a3tot += Number(data.a3)
        a4tot += Number(data.a4)
        a5tot += Number(data.a5)
        atot += Number(data.total)
      }
      let temp: any = {};
      temp.party_name = "GRAND TOTAL";
      temp.a1 = a1tot;
      temp.a2 = a2tot;
      temp.a3 = a3tot;
      temp.a4 = a4tot;
      temp.a5 = a5tot;
      temp.total = atot;
      this.data.invoiceList.push(temp)

    }

  }

  Onselectagent(type) {

    let temp = this.Agentlist.filter(el => el.name == type);
    this.agentdata = temp[0].genLedid;
    console.log(this.agentdata)

  }
  rowStyle(ind) {
    if (this.show_det) {
      if ((this.data.invoiceList.length - 1) === ind) {
        const style = {
          font: "caption",
        };
    
        return style;
      }


    }
  }




  getagent() {
    let params = {
      incharger: this.menu.param,
    };

    this.salesinvservice.getSalesagent(params).then((res: any) => {

      this.Agentlist = res;

    });
  }

  onnextdet() {
    this.show_det = true;
    console.log(this.data.invoiceList);
    this.agentEntry = this.data.invoiceList;
console.log(this.agentEntry)
    this.getMasterDetails()
  }
  onbackdet() {
    this.show_det = false;
    console.log(this.data.invoiceList);
    this.data.invoiceList = this.agentEntry;
     console.log(this.data.invoiceList)

  }
  getViewShade(type) {
    this.mode = 'Add'
    let ind = type;

    let params = {
      des_id: this.data.invoiceList[ind].des_id

    };
    // this.salesinvservice.getDesMasterDetails(params).then((res: any) => {
    //   this.data.invoiceList = res.data;
    //   console.log(this.data.invoiceList,this.mode);
    //   var bottom = document.querySelector("#salesTbody");
    //   setTimeout(() => {
    //     bottom.scrollTop = bottom.scrollHeight;
    //   }, 500);


    // });
    this.show_det = false;
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (
          this.listSelected[k].agent_name == all.data.invoiceList[ind].agent_name
        ) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getEditMode(ind) {
    this.mode = 'Edit';
    console.log(this.data.invoiceList);

  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  checkagent_name(code) {
    if (code.length == 6) {
      if (this.execApi) {
        this.execApi = false;

        let params = {
          agent_name: code,
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          // code = parseInt(code);
          // this.data.invoiceList[i].agent_name = parseInt(
          //   this.data.invoiceList[i].agent_name
          // );
          if (this.data.invoiceList[i].agent_name == code) {
            setTimeout(() => {
              this.invoicedata.agent_name = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "agent_name Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }
        }
      }
    }
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      // that.finyearCtrl.setValue(res.data[0].fin_id);
      // that.filter.finYrVal = res.data[0].finyear;
      that.invoicedata.finyear = res.data[0].finyear;
      that.invoicedata.fin_id = res.data[0].fin_id;

      this.selectYear()
    });
  }





  oncheckemptyrow() {

    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    params["agentdata"] = JSON.stringify(this.agentEntry);
    params["type"] = this.menu.param;

    let that = this;
     let temp = this.agentEntry[0].total - this.data.invoiceList[this.data.invoiceList.length-1].total
    swal({
      title: "PARTY ENTRY"+' '+ "<span style = \"color : red\">"+ temp+"</span>" +' '+ "PCS REMAINING",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok,Proceed!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .saveSalesDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal(res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });

  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/salesplanAdd/salesPlanadd.ts